import { Directive } from '@angular/core';
import {
    hasAnyPermission,
    hasAnyRole,
    PersonRolesDto,
    PersonsOrganisationDto,
    UserService
} from '@flyfreely-portal-ui/flyfreely';
import { WorkspaceStateService } from '@flyfreely-portal-ui/workspace';
import { AttachmentList } from './attachments-list/attachments-list.component';

/**
 * Manage the allow download permission based on the role.
 */
@Directive({
    selector: 'attachment-list[permissions]'
})
export class AttachmentPermissionsDirective {
    constructor(
        private attachmentList: AttachmentList,
        private userService: UserService,
        private sharedService: WorkspaceStateService
    ) {}

    ngOnInit() {
        const user = this.userService.getCurrentUser();
        const organisation = this.sharedService.getCurrentOrganisation();
        if (user == null || organisation.type !== 'organisation_loaded') {
            this.attachmentList.setAllowDownload(false);
            this.attachmentList.setAllowViewOthers(false);
            return;
        }
        this.attachmentList.setAllowDownload(
            (organisation.organisation.roles.length > 0 &&
                !hasAnyRole(organisation.organisation.roles, [
                    PersonRolesDto.Roles.READ_ONLY
                ])) ||
                user.type === 'SYSTEM_ADMIN'
        );
        this.attachmentList.setAllowViewOthers(
            (this.attachmentList.requestingOrganisationId == null ||
                organisation.organisation.id ===
                    this.attachmentList.requestingOrganisationId) &&
                (hasAnyPermission(
                    organisation.organisation,
                    PersonsOrganisationDto.Permissions.PERSON_LIST
                ) ||
                    user.type === 'SYSTEM_ADMIN')
        );
    }
}
